import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13 21a.97.97 0 0 1-.713-.288A.97.97 0 0 1 12 20a.97.97 0 0 1 .287-.712A.97.97 0 0 1 13 19h6V5h-6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 12 4a.97.97 0 0 1 .287-.712A.97.97 0 0 1 13 3h6q.824 0 1.413.587.586.589.587 1.413v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm-1.825-8H4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 12a.97.97 0 0 1 .288-.713A.97.97 0 0 1 4 11h7.175L9.3 9.125a.92.92 0 0 1-.275-.675q0-.4.275-.7a.95.95 0 0 1 .7-.313.95.95 0 0 1 .725.288L14.3 11.3q.3.3.3.7t-.3.7l-3.575 3.575a.93.93 0 0 1-.713.288 1.02 1.02 0 0 1-.712-.313.97.97 0 0 1-.263-.713.98.98 0 0 1 .288-.687z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }